export default __webpack_public_path__ + "static/gabrielwong-17994a38885adde19bb3b1a9fb6905bc.png";